import { render, staticRenderFns } from "./CreateOpenRouterChannelForm.vue?vue&type=template&id=e6bad288&scoped=true"
import script from "./CreateOpenRouterChannelForm.vue?vue&type=script&lang=js"
export * from "./CreateOpenRouterChannelForm.vue?vue&type=script&lang=js"
import style0 from "./CreateOpenRouterChannelForm.vue?vue&type=style&index=0&id=e6bad288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bad288",
  null
  
)

export default component.exports